export default __webpack_public_path__ + "static/media/shadow-dark-autumn.33da2fed.png";